// extracted by mini-css-extract-plugin
module.exports = {"sectionTitle":"CheckoutTitlePage_sectionTitle__2Z9iB","backShipping":"CheckoutTitlePage_backShipping__3ndcK"};